import { constants } from '../config';

const initialState = {
  show: false,
};

export default function setShowCookieReducer(state = initialState, action) {
  switch (action.type) {
    case constants.SHOW_COOKIES: {
      return {
        ...state,
        show: action.show,
      };
    }
    default:
      return state;
  }
}
